import { HttpErrorResponse, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';

export interface InterceptStrategy {
	isRefreshToken: boolean;

	isIntercepted(req: HttpRequest<any>): boolean;

	getHttpRequest(
		req: HttpRequest<any>,
		additionalParams?: Record<string, unknown>
	): HttpRequest<any>;

	additionalParams?(req?: HttpRequest<any>): Observable<Record<string, unknown>>;

	isPosibleTokenExpired(error: HttpErrorResponse): boolean;

	refreshToken(req?: HttpRequest<any>): Observable<Record<string, unknown>>;
}

export const expiredCodeSumax = ['000046', 'GEN000046'];
